import React from 'react'
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import { useHistory } from 'react-router';
import EmailInput from '../../components/Inputs/EmailInput';
import TextInput from '../../components/Inputs/TextInput';
import ReactSelect from '../../components/Inputs/ReactSelect';
import { COUNTRIES } from '../../helpers/selectOptions';
import DateInput from '../../components/Inputs/DateInput';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import useUsers from '../../store/users/usersContext';

function AddPatient() {
  
  const history = useHistory();

  const {
    addPatient
  } = useUsers();

  const [formError, setFormError] = React.useState({
    field: '',
    msg: ''
  });

  const [newPatient, _setNewPatient] = React.useState({
    email: null,
    country: null,
    city: null,
    address: null,
    postalCode: null,
    firstName: null,
    lastName: null,
    mobileNb: null,
    dateOfBirth: null,
    sex: null,
  });

  const setNewPatient = (newVal) => _setNewPatient({...newPatient, ...newVal});

  const countryOptions = [];
  if (!countryOptions.length) COUNTRIES.forEach(country => {
    countryOptions.push({
      value: country,
      label: country
    })
  });
  
  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }


  const handleCreate = () => {
    let element;
    if (!validateEmail(newPatient.email)) {
    element = document.getElementById('email');
    element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return setFormError({
        field: 'email',
        msg: "Please enter a valid email."
      });
    }
    if (newPatient.firstName === '' || newPatient.firstName === null) {
      element = document.getElementById('firstName');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      
      return setFormError({
        field: 'firstName',
        msg: "Please enter a first name."
      });
    }
    if (newPatient.lastName === '' || newPatient.lastName === null) {
      element = document.getElementById('lastName');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return setFormError({
        field: 'lastName',
        msg: "Please enter a last name."
      });
    }
    if (newPatient.dateOfBirth === '' || newPatient.dateOfBirth === null ) {
      element = document.getElementById('dateOfBirth');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return setFormError({
        field: 'dateOfBirth',
        msg: "Please enter the patient's date of birth."
      });
    }
    if (newPatient.sex === '' || newPatient.sex === null ) {
      element = document.getElementById('sex');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return setFormError({
        field: 'sex',
        msg: "Please enter the patient's sex."
      });
    }
    if (newPatient.country === '' || newPatient.country === null ) {
      return setFormError({
        field: 'country',
        msg: "Please enter the patient's country."
      });
    }
    if (newPatient.city=== '' || newPatient.city === null ) {
      return setFormError({
        field: 'city',
        msg: "Please enter the patient's city."
      });
    }
    if (newPatient.address=== '' || newPatient.address === null ) {
      return setFormError({
        field: 'address',
        msg: "Please enter the patient's address."
      });
    }
    if (newPatient.postalCode=== '' || newPatient.postalCode === null ) {
      return setFormError({
        field: 'postalCode',
        msg: "Please enter the patient's postal code."
      });
    }
    if (newPatient.mobileNb=== '' || newPatient.mobileNb === null ) {
      return setFormError({
        field: 'mobileNb',
        msg: "Please enter the patient's mobile number."
      });
    }
    addPatient(newPatient).then(() => {
      history.push('/manage-patients');
    });
  }

  const sexOptions = [
    {
      value: 'Male',
      label: 'Male'
    },
    {
      value: 'Female',
      label: 'Female'
    },
    {
      value: 'Other',
      label: 'Other'
    },
  ];
  
  return (
    <div className="flex flex-col">
      <div className="bg-white rounded shadow py-12 px-10">
        <div className='flex justify-between items-center'>
          <h1 className="mb-10 text-2xl text-secondary">Personal Information</h1>
        </div>
        <div className='grid grid-cols-4 gap-y-4 '>
          <EmailInput id='email' horizontal label='Email*'  inputClass='col-span-3' data={newPatient.email} onChange={(e) => setNewPatient({email: e.target.value})} />
          {formError.field === 'email' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput id='firstName' label='First name*' inputClass='col-span-3' value={newPatient.firstName} onChange={(e) => setNewPatient({firstName: e.target.value})}/>
          {formError.field === 'firstName' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput id='lastName' label='Last name*' inputClass='col-span-3' value={newPatient.lastName} onChange={(e) => setNewPatient({lastName: e.target.value})}/>
          {formError.field === 'lastName' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <DateInput id='dateOfBirth' label='Date of birth*' inputClass='col-span-3' data={newPatient.dateOfBirth} onChange={(e) => setNewPatient({dateOfBirth: e.target.value})} />
          {formError.field === 'dateOfBirth' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <ReactSelect id='sex' label='Sex*' options={sexOptions} value={newPatient.sex} inputClass='col-span-3' onChange={(e) => setNewPatient({ sex: e.value })} /> 
          {formError.field === 'sex' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
        </div>
      </div>
      <div className="bg-white rounded shadow py-12 px-10 mt-6">
        <div className='flex justify-between items-center'>
          <h1 className="mb-10 text-2xl text-secondary">Contact details</h1>
        </div>
        <div className='grid grid-cols-4 gap-y-4'>  
          <ReactSelect label='Country*' options={countryOptions} value={newPatient.country} inputClass='col-span-3' onChange={(e) => setNewPatient({ country: e.value })} /> 
          {formError.field === 'country' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput inputClass='col-span-3' label='City*' data={newPatient.city} onChange={(e) => setNewPatient({city: e.target.value})} />
          {formError.field === 'city' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput inputClass='col-span-3' label='Address*' data={newPatient.address} onChange={(e) => setNewPatient({address: e.target.value})} />
          {formError.field === 'address' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput inputClass='col-span-3' label='Postal code*' data={newPatient.postalCode} onChange={(e) => setNewPatient({postalCode: e.target.value})} />
          {formError.field === 'postalCode' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput inputClass='col-span-3' label='Mobile*' data={newPatient.mobileNb} onChange={(e) => setNewPatient({mobileNb: e.target.value})} />
          {formError.field === 'mobileNb' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
        </div>
      </div>
      <div className='flex flex-row-reverse mt-8 mb-4'>
        <PrimaryButton text='Create' onClick={handleCreate} className='min-w-180 ml-4'/>
        <SecondaryButton text='Cancel' onClick={() => history.push('/manage-patients')} className='min-w-180'/>
      </div>
    </div>
  )
}

export default AddPatient
